/**
 * 派单内容工厂组件
 * 根据订单类型渲染对应的派单内容
 */
import React from 'react'
import MaternityCenterDispatcherContent from './MaternityCenterDispatcherContent'
import DispatcherPlaceholder from './DispatcherPlaceholder'

const DispatcherContentFactory = (props) => {
  const { orderType, ...restProps } = props
  switch (orderType) {
    case 'maternity_center':
    case 'home_service':
      return <MaternityCenterDispatcherContent {...restProps} orderType={orderType} />
    case 'traditional_medicine':
    case 'dental':
      return <DispatcherPlaceholder />
    default:
      return <MaternityCenterDispatcherContent {...restProps} />
  }
}

export default DispatcherContentFactory
